var map = {
	"./arrow.svg": 46,
	"./circle_astroturfing.png": 67,
	"./circle_bandwagon.png": 68,
	"./circle_bot.png": 69,
	"./circle_darkads.png": 70,
	"./circle_falseflags.png": 71,
	"./circle_falskmedia.png": 72,
	"./circle_filterbubbla.png": 73,
	"./circle_gishgallop.png": 74,
	"./circle_hackning.png": 75,
	"./circle_halmgubbar.png": 76,
	"./circle_lockfåglar.png": 77,
	"./circle_personangrepp.png": 78,
	"./circle_trollfabrik.png": 79,
	"./circle_tystnadsspiralen.png": 80,
	"./circle_whataboutism.png": 81,
	"./djurforsok.jpg": 82,
	"./emojis/bigsmiley.svg": 32,
	"./emojis/blush.svg": 33,
	"./emojis/cool.svg": 14,
	"./emojis/emptystar.svg": 47,
	"./emojis/hearteyes.svg": 34,
	"./emojis/omg.svg": 35,
	"./emojis/oops.svg": 36,
	"./emojis/smiley.svg": 37,
	"./emojis/star.svg": 83,
	"./emojis/starface.svg": 15,
	"./img1.jpg": 84,
	"./img10.jpg": 85,
	"./img11.jpg": 86,
	"./img12.jpg": 87,
	"./img13.jpg": 88,
	"./img14.jpg": 89,
	"./img15.jpg": 90,
	"./img16.jpg": 91,
	"./img17.jpg": 92,
	"./img18.jpg": 93,
	"./img19.jpg": 94,
	"./img2.jpg": 95,
	"./img20.jpg": 96,
	"./img21.jpg": 97,
	"./img22.jpg": 98,
	"./img23.jpg": 99,
	"./img24.jpg": 100,
	"./img25.jpg": 101,
	"./img26.jpg": 102,
	"./img27.jpg": 103,
	"./img28.jpg": 104,
	"./img29.jpg": 105,
	"./img3.jpg": 106,
	"./img30.jpg": 107,
	"./img31.jpg": 108,
	"./img32.jpg": 109,
	"./img33.jpg": 110,
	"./img34.jpg": 111,
	"./img35.jpg": 112,
	"./img36.jpg": 113,
	"./img37.jpg": 114,
	"./img38.jpg": 115,
	"./img39.jpg": 116,
	"./img4.jpg": 117,
	"./img40.jpg": 118,
	"./img41.jpg": 119,
	"./img42.jpg": 120,
	"./img43.jpg": 121,
	"./img44.jpg": 122,
	"./img45.jpg": 123,
	"./img46.jpg": 124,
	"./img47.jpg": 125,
	"./img48.jpg": 126,
	"./img49.jpg": 127,
	"./img5.jpg": 128,
	"./img50.jpg": 129,
	"./img51.jpg": 130,
	"./img52.jpg": 131,
	"./img53.jpg": 132,
	"./img54.jpg": 133,
	"./img55.jpg": 134,
	"./img56.jpg": 135,
	"./img57.jpg": 136,
	"./img58.jpg": 137,
	"./img59.jpg": 138,
	"./img6.jpg": 139,
	"./img60.jpg": 140,
	"./img61.jpg": 141,
	"./img62.jpg": 142,
	"./img7.jpg": 143,
	"./img8.jpg": 144,
	"./img9.jpg": 145,
	"./logos/Skärmavbild 2020-12-15 kl. 07.48.07.png": 146,
	"./logos/region_norrbotten_logo.eps": 147,
	"./logos/region_norrbotten_logo.svg": 38,
	"./logos/rise_logo.png": 39,
	"./logos/sparbanken_logo.png": 40,
	"./pattern.ai": 148,
	"./pattern.jpg": 149,
	"./pattern.svg": 150,
	"./pattern_simple.png": 151,
	"./pattern_tile.png": 152,
	"./pattern_tile_hd.png": 153,
	"./simple_pattern.svg": 41,
	"./turn.svg": 31
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22;